import React, { FC } from 'react'
import { IRoleModel } from './RoleModel'
import DataTable, { TableColumn, TableAction } from '../../../../shared/components/DataTable'

interface RoleTableProps {
  roles: IRoleModel[]
  currentPage: number
  totalPages: number
  loading: boolean
  onPageChange: (page: number) => void
  onEdit: (role: IRoleModel) => void
  onDelete: (role: IRoleModel) => void
}

const RoleTable: FC<RoleTableProps> = ({
  roles,
  currentPage,
  totalPages,
  loading,
  onPageChange,
  onEdit,
  onDelete,
}) => {
  const columns: TableColumn<IRoleModel>[] = [
    {
      key: 'roleName',
      label: 'Rol Adı',
      sortable: true,
      render: (value) => (
        <span className='fw-bold text-dark'>{value}</span>
      ),
    },
    {
      key: 'description',
      label: 'Açıklama',
      render: (value) => <span className='text-muted'>{value}</span>,
    },
    {
      key: 'permissions',
      label: 'Yetki Sayısı',
      align: 'center',
      render: (value: string[]) => (
        <span className='badge badge-light-primary fs-7 fw-bold'>
          {value?.length ?? 0} yetki
        </span>
      ),
    },
    {
      key: 'active',
      label: 'Durum',
      align: 'center',
      render: (value) =>
        value ? (
          <span className='badge badge-light-success'>Aktif</span>
        ) : (
          <span className='badge badge-light-danger'>Pasif</span>
        ),
    },
  ]

  const actions: TableAction<IRoleModel>[] = [
    {
      label: 'Düzenle',
      icon: 'bi bi-pencil-square',
      className: 'btn-sm btn-light-warning',
      onClick: onEdit,
    },
    {
      label: 'Sil',
      icon: 'bi bi-trash',
      className: 'btn-sm btn-light-danger',
      onClick: onDelete,
    },
  ]

  return (
    <DataTable
      data={roles}
      columns={columns}
      actions={actions}
      currentPage={currentPage}
      totalPages={totalPages}
      loading={loading}
      onPageChange={onPageChange}
      emptyMessage='Henüz rol tanımlanmamış'
    />
  )
}

export default RoleTable
